var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('ImageSlider'),_c('Courses'),_c('AboutView'),_c('Event'),_c('Testimonial'),_c('Blog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }